import $ from 'jquery'

var intro = function () {
  if ($('.section-intro.active') && $('.intro-content__hero.loaded')) {
    setTimeout(function () {
      $('.intro-content').addClass('active');
    }, 3600)
  }
}

module.exports = intro;



// WEBPACK FOOTER //
// ./resources/assets/js/modules/intro.js